import React, { useEffect, useRef } from 'react';
import './sphere.css';

export default function Sphere() {
  const sphereRef = useRef(null);

  useEffect(() => {
    const sphere = sphereRef.current;
    if (!sphere) return;

    const setPosition = (x, y) => {
      sphere.style.left = `${x}px`;
      sphere.style.top = `${y}px`;
    };

    setPosition(window.innerWidth / 2, window.innerHeight / 2);

    const handleMouseMove = (event) => {
      setPosition(event.clientX, event.clientY);
    };

    const handleTouchMove = (event) => {
      const touch = event.touches[0];
      setPosition(touch.clientX, touch.clientY);
    };

    const handleTouchStart = (event) => {
      const touch = event.touches[0];
      setPosition(touch.clientX, touch.clientY);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: true });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  return (
    <div className="sphere-container">
      <div className="sphere" ref={sphereRef}>
        <div className="glow"></div>
        <div className="core"></div>
      </div>
    </div>
  );
}